var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-container row"},[(_vm.hasCampaigns)?_c('Box',{attrs:{"data":{
      name: _vm.campaignInfo.name
        ? _vm.campaignInfo.name
        : _vm.translateString('campaign'),
    },"type":"backdrop ","size":"full ","image":_vm.campaignInfo.image}}):_vm._e(),_vm._l((_vm.data),function(service){return _c('Box',{key:service.id,attrs:{"data":service,"isSelected":service.selected|| _vm.groupServicesSelected.includes(service.id),"isPromo":_vm.groupsWithPromo.includes(String(service.id)),"type":"serviceGroup "},on:{"action":_vm.action}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }